export const IMG_NONE = 'https://storage.googleapis.com/4p_backup_bucket/cms_content_media/243420807-default-image-1719472223955.jpg'